import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { withRouterProps } from '../../../utils/with-router-props'

import { apiResourceEndpoint, buildRoutePath, routes } from '../../../../constants/routes'
import { fetchApiDataIfNeeded } from '../../../../actions/api'
import { Link } from 'react-router-dom'
import { PaginationWrapper } from 'shs-pagination'
import moment from 'moment'
import AccountSidebar from '../../../shared/account-sidebar'

const selectadminUserPaginator = state => state.paginator.adminUser
const selectUsers = (state, accountId) => state.adminUser.filter(user => user.accountId === Number(accountId))
const makeUsers = createSelector(
    [selectUsers, selectadminUserPaginator],
    (users, paginator) => {
        if (paginator) {
            return users
                .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
                .sort((a, b) => {
                    if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                        return 1
                    }
                    return -1
                })
        }
        return []
    }
)

const mapStateToProps = (state, ownProps) => {
    const paginator = state.paginator.adminUser
    const users = makeUsers(state, ownProps.params.accountId)
    const account = state.adminAccounts.find(acc => acc.id === Number(ownProps.params.accountId))
    return { paginator, users, roles: state.roles, account }
}

const AdminUsersList = ({ dispatch, paginator, users, roles, params, account }) => {
    const accountId = params.accountId
    useEffect(() => {
        if (accountId) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/users', 'LIST', null), { filter: [`account_id|${accountId}`] }))
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('roles', 'LIST')))
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/accounts', 'VIEW', accountId)))
        }
    }, [dispatch, accountId])

    const renderUserRow = (user, index) => {
        const role = roles.find(r => r.id === user.roleId)
        const { id, firstName, lastName, email } = user
        return (
            <tr key={id}>
                <td className="index mobile-hide">{index}.</td>
                <td className="main">
                    <Link to={buildRoutePath(routes.adminUsersView.path, { accountId, userId: id })}>
                        {firstName} {lastName}
                    </Link>
                </td>
                <td className="main">{email}</td>
                <td className="main">{role ? role?.name : 'N/A'}</td>
                <td className="main mobile-hide">{moment(user.createdAt).format('MMM Do \'YY h:mm a')}</td>
            </tr>
        )
    }

    const handlePaginationUpdate = (paginationParams) => {
        if (accountId) {
            const paramsWithFilter = { ...paginationParams, filter: [`account_id|${accountId}`] }
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint(`admin/users`, 'LIST'), paramsWithFilter))
        }
    }

    const renderUsers = () => {
        if (!paginator) {
            return null
        }
        let allUsers = []
        users.forEach((user, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allUsers.push(renderUserRow(user, index))
        })
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: false } }}
                callbackFX={handlePaginationUpdate}>
                <table className="table">
                    <thead>
                        <tr>
                            <th className="mobile-hide">#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th className="mobile-hide">Created</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allUsers}
                    </tbody>
                </table>
            </PaginationWrapper>
        )
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Dashboard for {account?.name}</h1>
                        <p>Use the table below to view and manage users for this account.</p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sidebar-layout">
                    <div className="sidebar box">
                        <AccountSidebar account={account} />
                    </div>
                    <div className="main-content box">
                        <div className="container">
                            { renderUsers() }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminUsersList))
